<template>
    <div style="width: 99%; display: block; padding: 5px; margin-left: auto; margin-right: auto;">
        <!-- Your existing modals -->
        <b-modal id="modal-so-items" @hide="fetch_orders" scrollable title="DOMESTIC VENDOR ORDER" size="xl" hide-footer
        style="min-height: 700px;">
        <StockOrderItems
            v-on:done-items-so="close_so_items"
            style="min-height: 700px;"
            :viewdata="{
                stock_order_id: stock_order_id,
                stock_order_vendor_id: stock_order_vendor_id,
                schedule_eta: $root.schedule_eta
            }"
        />
    </b-modal>

    <b-modal id="email-domestic-po-modal" title="Send Domestic PO via Email" @hidden="resetEmailForm" hide-footer>
    <!-- Email form content remains the same -->
    <b-form @submit.prevent="sendDomesticPOEmail">
        <div class="row mb-3">
            <div class="col-md-12">
                <b-form-group label="Email Address" label-for="email-address" :state="!!emailForm.email">
                    <b-form-input
                        id="email-address"
                        v-model="emailForm.email"
                        type="email"
                        placeholder="Enter vendor email address"
                        required
                        :state="!!emailForm.email"
                    ></b-form-input>
                    <b-form-invalid-feedback>Email address is required</b-form-invalid-feedback>
                </b-form-group>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-12">
                <b-form-group label="Subject" label-for="email-subject">
                    <b-form-input
                        id="email-subject"
                        v-model="emailForm.subject"
                        placeholder="Email subject"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-12">
                <b-form-group label="Message" label-for="email-message">
                    <b-form-textarea
                        id="email-message"
                        v-model="emailForm.message"
                        placeholder="Optional message to include with the email"
                        rows="4"
                    ></b-form-textarea>
                </b-form-group>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-12">
                <h6>Order Details</h6>
                <div class="alert alert-info">
                    <strong>PO #:</strong> {{ emailForm.poNumber }}<br>
                    <strong>Vendor:</strong> {{ emailForm.vendorName }}<br>
                    <strong>Items:</strong> {{ emailForm.itemsCount }} items
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <b-button variant="secondary" @click="$bvModal.hide('email-domestic-po-modal')" class="mr-2">
                Cancel
            </b-button>
            <b-button variant="primary" type="submit" :disabled="!emailForm.email">
                Send Email
            </b-button>
        </div>
    </b-form>
</b-modal>

        <!-- Product Detail Modal - ADD THIS -->
        <ProductDetailModal 
            ref="productDetailModal"
            :productSku="currentDetailProductSku"
            :orderData="currentDetailOrderData"
            v-if="showProductDetail"
            @view-product="viewProductDetail"
            @open-product-detail="openProductDetail"
            @hidden="handleProductModalHidden"
        />

        <div style="display: block; margin-top: 10px;">
            <!-- Your existing filter code remains the same -->
            <div v-if="isMobile" class="d-flex justify-content-between align-items-center mb-2">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="filtersVisible = !filtersVisible"
              >
                <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
              </b-button>
            </div>

            <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
              <b-alert variant="secondary" show>
                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>SCHEDULE ETA</div>
                  <date-picker
                    v-model="date_range"
                    format="MM-DD-YYYY"
                    valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE"
                    range
                  ></date-picker>
                </div>

                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>STATUS</div>
                  <b-form-select :options="statuses" v-model="status">
                    <template #first>
                      <b-form-select-option :value="null">OPEN</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>VENDOR</div>
                  <b-form-select :options="packet.vendors" v-model="vendor"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>SHIP TO</div>
                  <b-form-select :options="filter_locations" v-model="ship_to_filter"></b-form-select>
                </div>

                <div style="width: 150px; margin: 5px; display: inline-block; vertical-align: top;">
                  <div>RECEIVING LOC</div>
                  <b-form-select :options="filter_receiving_locations" v-model="receiving_loc_filter"></b-form-select>
                </div>
              </b-alert>
            </b-collapse>

            <b-alert show variant="warning">
                <b-button v-if="this.packet.userDetails.userrole == 'admin' || this.packet.userDetails.userrole == 'locationadmin'" size="sm" variant="success" @click="add_new_stock_order">ADD NEW</b-button>
                <b-button size="sm" variant="primary" @click="fetch_orders">RELOAD</b-button>
            </b-alert>

            <div>
                <div v-if="items_being_loaded == true">
                    <loading :active="true" :can-cancel="false" :is-full-page="true">
                    </loading>
                </div>

                <div v-else>
                    <div v-if="items.length == 0">
                        <b-alert show variant="warning"> NO STOCK ORDERS</b-alert>
                    </div>
                    <div v-else>
                        <div class="diver">
                            <table>
                                <thead>
                                    <tr>
                                        <th style="width: 160px; background-color:lightblue;" class="srr">VENDOR NAME</th>
                                        <th style="width: 150px; background-color:lightblue;"  class="srr">PO #</th>
                                        <th style="width: 150px; background-color:lightblue;"  class="srr">INVOICE #</th>
                                        <th style="width: 100px; background-color:lightblue;"  class="srr">CREATED BY</th>
                                        <th style="width: 100px;background-color:lightblue;" class="srr">CREATED AT</th>
                                        <th class="srr" style="width: 120px; background-color:lightblue;">STATUS</th>
                                        <th class="srr" style="width: 150px; background-color:lightblue;">BILL TO</th>
                                        <th class="srr" style="width: 150px; background-color:lightblue;">SHIP TO</th>
                                        <th class="srr" style="width: 150px; background-color:lightblue;">RCVNG LOC</th>
                                        <th class="srr" style="width: 140px; background-color:lightyellow;">RQST ETA</th>
                                        <th class="srr" style="width: 140px; background-color:lightyellow">SCHEDULE ETA</th>
                                        <th class="srr" style="background-color:lightyellow">ITEMS</th>
                                        <th class="srr" style="width: 150px;background-color:lightyellow">CATEGORIES</th>
                                        <th class="srr" style="width: 100px;background-color:lightyellow">CUBES</th>
                                        <th class="srr" style="width: 100px; background-color:lightyellow">QTY</th>
                                        <th  class="srr" style="width: 120px; background-color:lightyellow">ITEMS ORDRD</th>
                                        <th  class="srr" style="width: 120px; background-color:lightyellow">ITEMS RCVD</th>
                                        <th  class="srr" style="width: 120px; background-color:lightyellow">ITEMS REMAIN</th>
                                        <th  class="srr" style="width: 170px; background-color:lightyellow">RCV DATES</th>
                                        <th class="srr" v-if="[
                                                'admin',
                                            ].includes(userDetails.userrole)"
                                            style="width: 120px ; background-color:lightgreen; ">INVOICE TOTAL</th>
                                        <th class="srr"
                                        v-if="[
                                            'admin',
                                        ].includes(userDetails.userrole)"
                                        style="width: 120px;  background-color:lightgreen;">TARIFF</th>
                                        <th class="srr"
                                        v-if="[
                                            'admin',
                                        ].includes(userDetails.userrole)"
                                        style="width: 120px;  background-color:lightgreen;">TRANSPORT</th>
                                        <th class="srr"
                                        v-if="[
                                            'admin',
                                        ].includes(userDetails.userrole)"
                                        style="width: 120px;  background-color:lightgreen;">OTHER COST</th>
                                        <th class="srr"
                                        v-if="[
                                            'admin',
                                        ].includes(userDetails.userrole)"
                                        style="width: 120px;  background-color:lightgreen;">LANDED</th>

                                        <th class="srr" style=" width: 60px;">
                                            <b-button
                                                size="sm"
                                                @click="isDetailsExpanded = !isDetailsExpanded"
                                                variant="outline-primary"
                                                :disabled="userDetails.userrole === 'warehouseuser'">
                                                {{ isDetailsExpanded ? 'HIDE' : 'SHOW' }}
                                            </b-button>
                                        </th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">MERCH INVOICE DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px;">MERCH INVOICE #</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">PYMT DUE DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">MERCH PAID DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px;">MERCH PYMT METHOD</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">TRUCK INV DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px;">TRUCK COMPANY</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px;">TRUCK INV #</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px;">INV AMT</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 140px;">TRUCK PAID DATE</th>
                                        <th v-if="isDetailsExpanded" class="srr" style="width: 120px;">MERCH PYMT METHOD</th>

                                        <th class="srr" style="width:250px">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item, idx in filteredItems" v-bind:key="idx">
                                        <td class="srrv">
                                            <div style="margin: 3px;">
                                                <b-form-select size="sm" :options="packet.vendors" :disabled="isItemDisabled(item)"
                                                    v-model="item.data.vendor_id" @change="handleVendorChange(item)"></b-form-select>
                                            </div>
                                        </td>
                                        <td class="srrv">
                                            <div style="margin: 3px;">
                                                <b-input size="sm" v-model="item.data.po_number"
                                                        :state="validateOrderNumber(item)" readonly></b-input>
                                            </div>
                                        </td>
                                        <td class="srrv">
                                            <div style="margin: 3px;">
                                                <b-input size="sm" v-model="item.data.invoice_number"
                                                        :disabled="isItemDisabled(item)"
                                                        placeholder="Invoice #"></b-input>
                                            </div>
                                        </td>
                                         <td class="srrv">
                                            {{ item.created_by }}
                                        </td>
                                        <td class="srrv">
                                            {{ formatDate(item.created_at) }}
                                        </td>
                                        <td class="srrv">
                                            <b-form-select
                                                size="sm"
                                                :options="getStatusOptions(item)"
                                                v-model="item.data.status"
                                                @change="handleStatusChange(item)"
                                                :disabled="isItemDisabled2(item)">
                                            </b-form-select>
                                        </td>
                                    <td class="srrv">
                                    <b-form-select
                                        size="sm"
                                        :options="bill_to_locations"
                                        v-model="item.data.bill_to"
                                        :disabled="isItemDisabled(item)"
                                        @change="handleBillToChange(item)"
                                    ></b-form-select>
                                </td>

                                <td class="srrv">
                                    <b-form-select
                                        size="sm"
                                        :options="ship_to_locations"
                                        v-model="item.data.ship_to"
                                        :disabled="isItemDisabled(item)"
                                        @change="handleShipToChange(item)"
                                    ></b-form-select>
                                </td>

                                <td class="srrv">
                                    <b-form-select
                                        size="sm"
                                        :options="filteredReceivingLocations(item)"
                                        :disabled="isItemDisabled(item)"
                                        v-model="item.data.receiving_location"
                                    ></b-form-select>
                                </td>
                                        <td class="srrv">
                                            <date-picker :disabled="isItemDisabled(item)" v-model="item.data.requested_eta" format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px;

                                                font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"></date-picker>
                                        </td>
                                        <td class="srrv"  style="background: lightyellow;">
                                            <date-picker :disabled="isItemDisabled(item)" v-model="item.data.final_eta" format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"
                                                @change="handleEtaDateChange(item)"></date-picker>
                                        </td>
                                        <td class="srrv">
                                            <div v-if="item.showDetails">
                                                <button v-if="Array.isArray(item.product_skus) && item.product_skus.length > 0" @click="item.showDetails = false">HIDE</button>
                                                <div v-for="(p, pidx) in item.product_skus" :key="pidx" style="display: block; margin: 5px;">
                                                    <div class="box" variant="success" style="font-size: 11px;">
                                                        {{ p.product_name }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <button @click="item.showDetails = true" :disabled="!Array.isArray(item.product_skus) || item.product_skus.length === 0">
                                                    SHOW {{ (item.product_skus || []).length }} ITEMS
                                                </button>
                                                <span v-if="Array.isArray(item.product_skus) && item.product_skus.length === 0" style="color: #999; font-size: 11px;">

                                                </span>
                                            </div>
                                        </td>
                                        <td class="srrv">
                                        <div v-if="item.showCategories">
                                            <button v-if="Array.isArray(item.categories) && item.categories.length > 0" @click="item.showCategories = false">HIDE</button>
                                            <div v-for="(ct, ctidx) in item.categories" :key="ctidx" style="display: block; margin: 5px;">
                                            <div class="box" variant="primary" style="font-size: 11px;">
                                                {{ packet.categoriesdict[ct] }}
                                            </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <button @click="item.showCategories = true" :disabled="Array.isArray(item.categories) && item.categories.length === 0">
                                            SHOW {{ (item.categories || []).length }} CATGRS
                                            </button>
                                        </div>
                                        </td>
                                        <td class="srrv">{{ item.cubes && Number(item.cubes).toFixed(2) }}</td>
                                        <td class="srrv">{{ item.quantity_ordered }}</td>
                                        <td  class="srrv" style="background: lightyellow;">
                                            {{ item.quantity_ordered }}
                                        </td>

                                        <td  class="srrv" style="background: lightyellow;">
                                            {{ item.received_items }}
                                        </td>
                                        <td  class="srrv" style="background: lightyellow;">
                                            {{ item.remaining_items }}
                                        </td>

                                    <td class="srrv">
                                        <div v-if="item.show_receivingdates">
                                            <button v-if="Array.isArray(item.receiving_dates) && item.receiving_dates.length > 0"
                                                    @click="item.show_receivingdates = false">HIDE</button>
                                            <div v-for="(date, dateIdx) in item.receiving_dates" :key="dateIdx"
                                                style="display: block; margin: 5px;" v-if="date">
                                            <div class="box" variant="primary" style="font-size: 11px;">
                                                {{ date }}
                                            </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <button @click="item.show_receivingdates = true"
                                                    :disabled="!Array.isArray(item.receiving_dates) || item.receiving_dates.length === 0">
                                            SHOW {{ (item.receiving_dates || []).length }} RCVG DATES
                                            </button>
                                        </div>
                                        </td>
                                        <td class="srrv"v-if="[
                                            'admin',
                                            ].includes(userDetails.userrole)">
                                            <b-input :disabled="isItemDisabled(item)" size="sm" readonly v-model="item.total_fob_price" type="number"
                                            @input="calculateLandedCost(item)"></b-input>
                                        </td>
                                        <td class="srrv"
                                        v-if="[
                                            'admin',
                                        ].includes(userDetails.userrole)">
                                        <b-input :disabled="isItemDisabled(item)" size="sm" v-model="item.data.tariff" type="number"
                                            @input="calculateLandedCost(item)"></b-input>
                                        </td>
                                        <td class="srrv"
                                        v-if="[
                                                'admin',
                                            ].includes(userDetails.userrole)">
                                            <b-input :disabled="isItemDisabled(item)" size="sm" v-model="item.data.transport" type="number"
                                            @input="calculateLandedCost(item)"></b-input>
                                        </td>
                                        <td class="srrv"
                                        v-if="[
                                                    'admin',
                                                ].includes(userDetails.userrole)">
                                            <b-input :disabled="isItemDisabled(item)" size="sm" v-model="item.data.other_cost" type="number"
                                            @input="calculateLandedCost(item)"></b-input>
                                        </td>
                                        <td class="srrv"
                                        v-if="[
                                                'admin',
                                            ].includes(userDetails.userrole)">
                                        <b-input size="sm" v-model="item.data.landed" type="number" readonly></b-input>
                                        </td>
                                        <td class="srrv"></td>

                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #f3e5f5;">
                                            <date-picker v-model="item.data.merch_invoice_date" format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"></date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #f3e5f5;">
                                            <b-input size="sm" v-model="item.data.merch_invoice_num"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #f3e5f5;">
                                            <date-picker v-model="item.data.merch_payment_due_date" format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"></date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #f3e5f5;">
                                            <date-picker v-model="item.data.merch_paid_date" format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"></date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: #f3e5f5;">
                                            <b-form-select size="sm" :options="pms"
                                                v-model="item.data.merch_payment_method"></b-form-select>
                                        </td>

                                        <td v-if="isDetailsExpanded" class="srrv" style="background: lightyellow;">
                                            <date-picker v-model="item.data.truck_invoice_date" format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"></date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: lightyellow;">
                                            <b-input size="sm" v-model="item.data.truck_company"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: lightyellow;">
                                            <b-input size="sm" v-model="item.data.truck_invoice_num"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: lightyellow;">
                                            <b-input size="sm" v-model="item.data.truck_invoice_amount"
                                                type="number"></b-input>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: lightyellow;">
                                            <date-picker v-model="item.data.truck_invoice_paid_date" format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 4px; font-size: 11px; text-align: center; border: 1px solid gray; width: 120px;"></date-picker>
                                        </td>
                                        <td v-if="isDetailsExpanded" class="srrv" style="background: lightyellow;">
                                            <b-form-select size="sm" :options="pms"
                                                v-model="item.data.truck_invoice_payment_method"></b-form-select>
                                        </td>
                                        <td class="srrv">
                                       <div style="display: inline-block;">
                                                <b-button
                                                    v-if="item.id && ((item.product_skus || []).length > 0 || isAdmin || isLocationAdmin)"
                                                    size="sm"
                                                    variant="outline-success"
                                                    @click="view_item(item)"
                                                    v-b-tooltip.hover
                                                    title="VIEW ITEMS">
                                                    <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>

                                            <!-- ADD PRODUCT DETAIL BUTTON HERE -->
                                            <div style="display: inline-block;">
                                                <b-button 
                                                    size="sm" 
                                                    variant="outline-info" 
                                                    @click="showProductDetailModal(item)"
                                                    v-b-tooltip.hover 
                                                    title="VIEW PRODUCT DETAILS"
                                                    :disabled="!item || !item.product_skus || item.product_skus.length === 0"
                                                >
                                                    <b-icon icon="grid-3x3-gap-fill" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>

                                            <div style="display: inline-block;">
                                                <b-button :disabled="isItemDisabled2(item)" size="sm" variant="outline-primary"
                                                        @click="update_stock_order(item)" v-b-tooltip.hover title="SAVE">
                                                    <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>

                                            <!-- PDF Generation Button -->
                                            <div style="display: inline-block;">
                                                <b-button
                                                v-if="item.id && ((item.product_skus || []).length > 0 && isAdmin)"
                                                    size="sm"
                                                    variant="outline-info"
                                                    @click="generateDomesticPDF(item)"
                                                    :disabled="!item.data.po_number || !item.data.vendor_id"
                                                    v-b-tooltip.hover
                                                    title="GENERATE PDF">
                                                    <b-icon icon="file-earmark-pdf" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>

                                            <!-- Email Button -->
                                            <div style="display: inline-block;">
                                                <b-button
                                                v-if="item.id && ((item.product_skus || []).length > 0 && isAdmin)"
                                                    size="sm"
                                                    variant="outline-warning"
                                                    @click="showEmailModal(item)"
                                                    :disabled="!item.data.po_number || !item.data.vendor_id"
                                                    v-b-tooltip.hover
                                                    title="SEND EMAIL">
                                                    <b-icon icon="envelope" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </div>


                                                     <div style="display: inline-block;">
                                                <b-button
                                                size="sm"
                                                variant="outline-danger"
                                                v-if="packet.userDetails.userrole == 'admin'"
                                                @click="delete_order(item)"
                                                v-b-tooltip.hover
                                                :title="item.data.status === 8 ? 'DELETE ORDER' : 'Only archived orders can be deleted'"
                                                :disabled="item.data.status !== 8"
                                            >
                                                <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css'
    import StockOrderItems from "@/components/VendorOrders/StockOrderItems"
    import ProductDetailModal from "@/components/VendorOrders/ProductDetailModal" // ADD THIS IMPORT
    import { BIconFunnelFill } from 'bootstrap-vue'

    export default {
        name: "ListStockOrders",
        props: [],
        components: { 
            flatPickr, 
            Loading, 
            DatePicker, 
            VueSimpleSuggest, 
            StockOrderItems,
            ProductDetailModal // ADD THIS
        },
        data: function () {
            return {
                packet: {},
                items: [],
                items_being_loaded: null,
                statuses: [
                    {value: 1, text: "NEW"},
                    {value: 2, text: "ORDERED"},
                    {value: 3, text: "SCHEDULED"},
                    {value: 4, text: "IN-TRANSIT"},
                    {value: 5, text: "PARTIAL"},
                    {value: 6, text: "RECEIVED"},
                    {value: 7, text: "COMPLETED"},
                    {value: 8, text: "ARCHIVED"},
                ],
                no_items_status: [],
                emailForm: {
                    email: '',
                    subject: '',
                    message: '',
                    poNumber: '',
                    vendorName: '',
                    itemsCount: 0,
                    stockOrderId: null
                },
                pms: [
                    { value: "CHECK", text: "CHECK" },
                    { value: "WIRE", text: "WIRE" },
                    { value: "CASH", text: "CASH" },
                ],
                stock_order_id: null,
                stock_order_vendor_id: null,
                create_new: false,

                // Filters
                status: null,
                vendor: null,
                date_range: [],
                ship_to_filter: null,
                receiving_loc_filter: null,

                // Location options
                locations: [],
                receiving_locations: [],
                filter_locations: [],
                filter_receiving_locations: [],

                isDetailsExpanded: false,
                vendorOrderCounters: {},
                userDetails: JSON.parse(localStorage.userDetails),
                filtersVisible: false,
                isMobile: false,

                // ADD THESE FOR PRODUCT DETAIL MODAL
                currentDetailProductSku: null,
                currentDetailOrderData: null,
                showProductDetail: false,
            }
        },
        computed: {
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            },

            isLocationAdmin(){
              return this.packet.userDetails.userrole === 'locationadmin';
            },

            mappedLocations: function() {
                return this.locations.map(loc => {
                    if (loc.text === '9TH ST , 101 wH, FOLCROFT') {
                        return {...loc, text: 'MECCA WHOLESALE'};
                    }
                    return loc;
                });
            },

            filteredShipToLocations: function() {
                return function() {
                    return this.ship_to_locations;
                };
            },

            filteredReceivingLocations: function() {
                return function(item) {
                    const shipToLocation = item.data.ship_to;

                    if (!shipToLocation) {
                        return this.receiving_dropdown_locations;
                    }

                    const shipToText = this.getLocationText(shipToLocation);

                    if (shipToText === 'MECCA WHOLESALE') {
                        return this.receiving_dropdown_locations.filter(loc =>
                            ['9TH ST ', '101 WH', 'FOLCROFT'].some(whLocation =>
                                loc.text.includes(whLocation)
                            )
                        );
                    } else {
                        return this.receiving_dropdown_locations.filter(loc =>
                            loc.value === shipToLocation || loc.text === shipToText
                        );
                    }
                };
            },
            bill_to_locations() {
                const excludedBillTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING', '9TH ST ', '101 WH', 'FOLCROFT'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let billToLocations = allLocations
                    .filter(loc => !excludedBillTo.includes(loc.text))
                    .map(this.replaceMecca);

                const meccaWholesaleOption = { value: 'MECCA_WHOLESALE', text: 'MECCA WHOLESALE', isMecca: true };
                if (!billToLocations.find(l => l.text === 'MECCA WHOLESALE')) {
                    billToLocations.unshift(meccaWholesaleOption);
                }

                const userLocationId = this.packet.userDetails.properties.location_id;
                const isAdmin = this.packet.userDetails.userrole === 'admin';
                if (!isAdmin) {
                    billToLocations = billToLocations.filter(d => d.value == userLocationId);
                }

                return billToLocations;
            },
            ship_to_locations() {
                const excludedShipTo = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'];
                const allLocations = this.packet.locations.filter(d => d.text != 'All');

                let shipToLocations = allLocations
                    .filter(loc => !excludedShipTo.includes(loc.text))
                    .map(this.replaceMecca);

                const warehouseLocations = ['9TH ST ', '101 WH', 'FOLCROFT'];
                const hasMeccaWholesale = shipToLocations.some(loc => loc.text === 'MECCA WHOLESALE');

                if (!hasMeccaWholesale) {
                    shipToLocations = shipToLocations.filter(loc =>
                        !warehouseLocations.some(wh => loc.text.includes(wh))
                    );

                    const meccaOption = allLocations.find(loc =>
                        warehouseLocations.some(wh => loc.text.includes(wh))
                    );

                    if (meccaOption) {
                        shipToLocations.unshift({
                            value: 'MECCA_WHOLESALE',
                            text: 'MECCA WHOLESALE',
                            isMecca: true
                        });
                    }
                }

                const userLocationId = this.packet.userDetails.properties.location_id;
                const isAdmin = this.packet.userDetails.userrole === 'admin';
                if (!isAdmin) {
                    shipToLocations = shipToLocations.filter(d => d.value == userLocationId);
                }

                return shipToLocations;
            },

            filteredItems: function () {
                let that = this;
                return this.items.filter(function (d) {
                    return (
                        ((that.vendor) ? d.data.vendor_id == that.vendor : true) &&
                        ((!that.status)
                        ? [1, 2, 3, 4, 5].includes(d.data.status)
                        : (that.status)
                        ? d.data.status == that.status
                        : true) &&
                        ((that.date_range.length == 2 && that.date_range.includes(null) == false) ?
                            d.data.final_eta >= that.date_range[0] && d.data.final_eta <= that.date_range[1] : true) &&
                        ((that.ship_to_filter) ? d.data.ship_to == that.ship_to_filter : true) &&
                        ((that.receiving_loc_filter) ? d.data.receiving_location == that.receiving_loc_filter : true)
                    );
                });
            },
        },
        mounted() {
            this.handleResize()
            window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            // ===== ADD THESE METHODS FOR PRODUCT DETAIL MODAL =====
            showProductDetailModal(item) {
                console.log('Opening product detail modal with item:', item);
                
                if (!item || !item.product_skus || item.product_skus.length === 0) {
                    this.$bvToast.toast("No products found in this stock order", { 
                        title: "Info", 
                        variant: "info" 
                    });
                    return;
                }
                
                // Reset data first to ensure clean state
                this.currentDetailProductSku = null;
                this.currentDetailOrderData = null;
                this.showProductDetail = false;
                
                this.$nextTick(() => {
                    this.currentDetailOrderData = item;
                    this.currentDetailProductSku = item.product_skus[0].product_sku || item.product_skus[0].sku;
                    this.showProductDetail = true;
                    
                    console.log('Set product detail data:', {
                        sku: this.currentDetailProductSku,
                        orderData: this.currentDetailOrderData
                    });
                    
                    this.$nextTick(() => {
                        this.$bvModal.show('modal-product-detail');
                    });
                });
            },

            handleProductModalHidden() {
                console.log('Product modal hidden, resetting data');
                setTimeout(() => {
                    this.showProductDetail = false;
                    this.currentDetailProductSku = null;
                    this.currentDetailOrderData = null;
                    console.log('Product detail data reset');
                }, 300);
            },

            viewProductDetail(sku) {
                this.$bvModal.hide('modal-product-detail');
                this.currentDetailProductSku = sku;
                this.currentDetailOrderData = null;
                setTimeout(() => {
                    this.$bvModal.show('modal-product-detail');
                }, 300);
            },

            openProductDetail(sku) {
                this.$bvToast.toast(
                    `Opening full details for SKU: ${sku}`,
                    { title: "Info", variant: "info" }
                );
            },
            // ===== END PRODUCT DETAIL MODAL METHODS =====

            handleResize() {
                this.isMobile = window.innerWidth < 768
            },
            generateDomesticPDF(item) {
                const that = this;

                if (!item.data.po_number || !item.data.vendor_id) {
                    this.$bvToast.toast("PO number and vendor are required to generate PDF", {
                        title: "Error",
                        autoHideDelay: 1500,
                        variant: "danger"
                    });
                    return;
                }

                const vendorName = this.getVendorName(item.data.vendor_id);
                const billingLocation = this.getLocationText(item.data.bill_to);
                const shippingLocation = this.getLocationText(item.data.ship_to);
                const receivingLocation = this.getLocationText(item.data.receiving_location);
                const statusObj = this.statuses.find(s => s.value === item.data.status);
                const statusText = statusObj ? statusObj.text : 'NEW';

                console.log("Checking product_skus structure:", item.product_skus);
                
                let itemsForPDF = [];
                
                if (item.product_skus && item.product_skus.length > 0) {
                    if (item.product_skus[0] && item.product_skus[0].quantity_ordered !== undefined) {
                        itemsForPDF = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: product.quantity_ordered || 1
                        }));
                        console.log("✅ Using actual individual quantities from product_skus");
                    } else {
                        const quantityPerItem = Math.floor(Number(item.quantity_ordered) / item.product_skus.length);
                        console.log("⚠️ No individual quantities found, dividing total:", item.quantity_ordered);
                        
                        itemsForPDF = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: quantityPerItem > 0 ? quantityPerItem : 1
                        }));
                    }
                } else {
                    itemsForPDF = [];
                }

                console.log("Final items being sent to PDF:", itemsForPDF);

                const pdfData = {
                    po_number: item.data.po_number,
                    vendor: vendorName,
                    receiving_location: receivingLocation,
                    shipping_location: shippingLocation,
                    billing_location: billingLocation,
                    eta: item.data.final_eta,
                    invoice_number: item.data.invoice_number,
                    status: statusText,
                    items: itemsForPDF,
                    send_email: false,
                    email: ''
                };

                this.items_being_loaded = true;

                Requestor.postSyncP(
                    "/api/vendor/generate_domestic_pdf/",
                    pdfData,
                    this,
                    function(response) {
                        that.items_being_loaded = false;

                        if (response.data && response.data.error) {
                            that.$bvToast.toast(response.data.error, {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            });
                            return;
                        }

                        try {
                            const blob = new Blob([response.data], { type: "application/pdf" });
                            const pdfUrl = URL.createObjectURL(blob);
                            window.open(pdfUrl, "_blank");

                            that.$bvToast.toast("PDF generated successfully!", {
                                title: "Success",
                                autoHideDelay: 1500,
                                variant: "success"
                            });

                        } catch (err) {
                            console.error("Error processing PDF blob:", err);
                            that.$bvToast.toast("Failed to display PDF", {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            });
                        }
                    },
                    function(error) {
                        that.items_being_loaded = false;
                        console.error("PDF generation API error:", error);
                        that.$bvToast.toast("Failed to generate PDF", {
                            title: "Error",
                            autoHideDelay: 1500,
                            variant: "danger"
                        });
                    }
                );
            },

            sendDomesticPOEmail() {
                const that = this;
                const item = this.items.find(i => i.id === this.emailForm.stockOrderId);

                if (!item) {
                    this.$bvToast.toast("Order not found", {
                        title: "Error",
                        autoHideDelay: 1500,
                        variant: "danger"
                    });
                    return;
                }

                const vendorName = this.getVendorName(item.data.vendor_id);
                const billingLocation = this.getLocationText(item.data.bill_to);
                const shippingLocation = this.getLocationText(item.data.ship_to);
                const receivingLocation = this.getLocationText(item.data.receiving_location);
                const statusObj = this.statuses.find(s => s.value === item.data.status);
                const statusText = statusObj ? statusObj.text : 'NEW';

                let itemsForEmail = [];
                
                if (item.product_skus && item.product_skus.length > 0) {
                    if (item.product_skus[0] && item.product_skus[0].quantity_ordered !== undefined) {
                        itemsForEmail = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: product.quantity_ordered || 1
                        }));
                        console.log("✅ Email: Using actual individual quantities from product_skus");
                    } else {
                        const quantityPerItem = Math.floor(Number(item.quantity_ordered) / item.product_skus.length);
                        itemsForEmail = item.product_skus.map(product => ({
                            sku: product.product_sku,
                            name: product.product_name,
                            quantity: quantityPerItem > 0 ? quantityPerItem : 1
                        }));
                    }
                } else {
                    itemsForEmail = [];
                }

                const emailData = {
                    po_number: item.data.po_number,
                    vendor: vendorName,
                    receiving_location: receivingLocation,
                    shipping_location: shippingLocation,
                    billing_location: billingLocation,
                    eta: item.data.final_eta,
                    invoice_number: item.data.invoice_number,
                    status: statusText,
                    items: itemsForEmail,
                    send_email: true,
                    email: this.emailForm.email,
                    subject: this.emailForm.subject,
                    message: this.emailForm.message
                };

                this.items_being_loaded = true;

                Requestor.postSyncP(
                    "/api/vendor/generate_domestic_pdf/",
                    emailData,
                    this,
                    function(response) {
                        that.items_being_loaded = false;

                        if (response.data && response.data.error) {
                            that.$bvToast.toast(response.data.error, {
                                title: "Error",
                                autoHideDelay: 1500,
                                variant: "danger"
                            });
                            return;
                        }

                        that.$bvToast.toast(`Email sent successfully to ${that.emailForm.email}`, {
                            title: "Success",
                            autoHideDelay: 2000,
                            variant: "success"
                        });

                        that.$bvModal.hide('email-domestic-po-modal');
                        that.resetEmailForm();
                    },
                    function(error) {
                        that.items_being_loaded = false;
                        console.error("Email sending error:", error);
                        that.$bvToast.toast("Failed to send email", {
                            title: "Error",
                            autoHideDelay: 1500,
                            variant: "danger"
                        });
                    }
                );
            },

            getStatusText(item) {
                const statusObj = this.statuses.find(s => s.value === item.data.status);
                return statusObj ? statusObj.text : 'NEW';
            },

            showEmailModal(item) {
                if (!item.data.po_number || !item.data.vendor_id) {
                    this.$bvToast.toast("PO number and vendor are required to send email", {
                        title: "Error",
                        autoHideDelay: 1500,
                        variant: "danger"
                    });
                    return;
                }

                this.emailForm = {
                    email: '',
                    subject: `Purchase Order: ${item.data.po_number}`,
                    message: `Dear Vendor,\n\nPlease find attached purchase order ${item.data.po_number}.\n\nThank you,\nFurniture Mecca`,
                    poNumber: item.data.po_number,
                    vendorName: this.getVendorName(item.data.vendor_id),
                    itemsCount: (item.product_skus || []).length,
                    stockOrderId: item.id
                };

                this.$bvModal.show('email-domestic-po-modal');
            },

            resetEmailForm() {
                this.emailForm = {
                    email: '',
                    subject: '',
                    message: '',
                    poNumber: '',
                    vendorName: '',
                    itemsCount: 0,
                    stockOrderId: null
                };
            },

            getLocationText: function(locationValue) {
                if (!locationValue) return '';

                if (locationValue === 'MECCA_WHOLESALE') {
                    return 'MECCA WHOLESALE';
                }

                const billToLoc = this.bill_to_locations.find(loc => loc.value === locationValue);
                if (billToLoc) return billToLoc.text;

                const shipToLoc = this.ship_to_locations.find(loc => loc.value === locationValue);
                if (shipToLoc) return shipToLoc.text;

                const allLoc = this.packet.locations.find(loc => loc.value === locationValue);
                return allLoc ? allLoc.text : '';
            },

            replaceMecca: function(location) {
                if (location.text === '9TH ST , 101 WH, FOLCROFT') {
                    return { ...location, text: 'MECCA WHOLESALE', isMecca: true };
                }

                if (location.text.includes('9TH ST ') || location.text.includes('101 WH') || location.text.includes('FOLCROFT')) {
                    return { ...location, isMeccaLocation: true };
                }

                return location;
            },

            handleShipToChange: function(item) {
                const shipToLocation = item.data.ship_to;
                item.data.receiving_location = null;

                if (shipToLocation && shipToLocation !== 'MECCA_WHOLESALE') {
                    item.data.receiving_location = shipToLocation;
                }
            },

            handleBillToChange: function(item) {
                // Bill-to is now independent
            },

            delete_order: function(item){
                if (!item.id){
                    this.$vex.dialog.alert(
                        {message: "PLEASE SAVE THE ORDER FIRST BEFORE DELETING IT."}
                    );
                    return
                }
                let data = {id: item.id};
                let that = this;
                let path = "/api/vendor/delete_stock_order/"
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "ERROR", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "DELETED",
                            {title: "SUCCESS", autoHideDelay: 1500, variant:"success"}
                        );
                        that.items=that.items.filter(function(d){return d.id != item.id});
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred in deleting. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },

            isItemDisabled2(item) {
                const completedStatuses = [7,8];

                if (this.packet.userDetails.userrole !== 'admin' && this.packet.userDetails.userrole !== 'locationadmin') {
                    return true;
                }

                if (completedStatuses.includes(item.data.status)) {
                    return true;
                }

                return false;
            },

            isItemDisabled(item) {
                const completedStatuses = [6, 7, 8];

                if (this.packet.userDetails.userrole !== 'admin' && this.packet.userDetails.userrole !== 'locationadmin') {
                    return true;
                }

                if (completedStatuses.includes(item.data.status)) {
                    return true;
                }

                return false;
            },

            isWarehouseUser() {
                return this.packet.userDetails && this.packet.userDetails.userrole === 'warehouseuser';
            },

            calculateLandedCost: function(item) {
                const invoiceTotal = Number(item.total_fob_price) || 0;
                const tariff = Number(item.data.tariff) || 0;
                const transport = Number(item.data.transport) || 0;
                const otherCost = Number(item.data.other_cost) || 0;

                const totalAdditionalCosts = tariff + transport + otherCost;
                const allocationRatio = invoiceTotal > 0 ? totalAdditionalCosts / invoiceTotal : 0;

                item.data.landed = (invoiceTotal + totalAdditionalCosts).toFixed(2);
                item.data.allocation_ratio = allocationRatio.toFixed(4);
            },

            formatDate: function(date) {
                if (!date) return '';
                return moment(date).format('MM-DD-YYYY');
            },

            getVendorName: function(vendorId) {
                if (!vendorId) return '';
                const vendor = this.packet.vendors.find(v => v.value == vendorId);
                return vendor ? vendor.text : '';
            },

            handleVendorChange: function(item) {
                if (item.data.vendor_id) {
                    this.generateOrderNumber(item);
                    item.data.status = 1;
                    this.autoSetMeccaWholesaleLocations(item);
                } else {
                    item.data.po_number = '';
                }
            },

            autoSetMeccaWholesaleLocations: function(item) {
                const meccaBillTo = this.bill_to_locations.find(loc =>
                    loc.text === 'MECCA WHOLESALE' || loc.value === 'MECCA_WHOLESALE'
                );

                const meccaShipTo = this.ship_to_locations.find(loc =>
                    loc.text === 'MECCA WHOLESALE' || loc.value === 'MECCA_WHOLESALE'
                );

                if (meccaBillTo) {
                    item.data.bill_to = meccaBillTo.value;
                }

                if (meccaShipTo) {
                    item.data.ship_to = meccaShipTo.value;

                    const defaultReceivingLoc = this.receiving_dropdown_locations.find(loc =>
                        loc.text.includes('9TH ST')
                    );

                    if (defaultReceivingLoc) {
                        item.data.receiving_location = defaultReceivingLoc.value;
                    }
                }
            },

            generateOrderNumber: function(item) {
                const vendorId = item.data.vendor_id;
                const vendorName = this.getVendorName(vendorId);

                if (!vendorName) return;

                if (!this.vendorOrderCounters[vendorId]) {
                    let maxNumber = 999;

                    this.items.forEach(order => {
                        if (order.data.vendor_id === vendorId && order.data.po_number) {
                            const parts = order.data.po_number.split('-');
                            if (parts.length > 1) {
                                const numberPart = parseInt(parts[parts.length - 1]);
                                if (!isNaN(numberPart) && numberPart > maxNumber) {
                                    maxNumber = numberPart;
                                }
                            }
                        }
                    });

                    this.vendorOrderCounters[vendorId] = maxNumber;
                }

                this.vendorOrderCounters[vendorId]++;
                item.data.po_number = `${vendorName}-${this.vendorOrderCounters[vendorId]}`;
                item.data.status = 1;
                this.autoSetMeccaWholesaleLocations(item);
            },

            getStatusOptions: function(item) {
                const currentStatus = item.data.status;
                const noItemsReceived = item.received_items === 0;
                const hasPONumber = item.data.po_number && item.data.po_number.trim() !== '';

                const STATUS = {
                    NEW: 1,
                    ORDERED: 2,
                    SCHEDULED: 3,
                    IN_TRANSIT: 4,
                    PARTIAL: 5,
                    RECEIVED: 6,
                    COMPLETED: 7,
                    ARCHIVED: 8
                };

                if (Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                    return this.statuses.map(status => ({
                        ...status,
                        disabled: ![STATUS.ORDERED, STATUS.ARCHIVED].includes(status.value)
                    }));
                }

                let options = this.statuses.map(status => {
                    let disabled = false;

                    if (hasPONumber && currentStatus !== STATUS.NEW && status.value !== STATUS.NEW) {
                        disabled = true;
                    }

                    if (status.value === STATUS.ARCHIVED) {
                        disabled = !noItemsReceived;
                        return {
                            ...status,
                            disabled: disabled
                        };
                    }

                    if ([STATUS.PARTIAL, STATUS.COMPLETED, STATUS.ARCHIVED].includes(currentStatus)) {
                        disabled = true;
                    }
                    else if (currentStatus === STATUS.NEW) {
                        disabled = ![STATUS.NEW, STATUS.ORDERED, STATUS.SCHEDULED, STATUS.ARCHIVED].includes(status.value);
                    }
                    else if (currentStatus === STATUS.ORDERED) {
                        disabled = ![STATUS.ORDERED, STATUS.SCHEDULED, STATUS.IN_TRANSIT].includes(status.value);
                    }
                    else if (currentStatus === STATUS.SCHEDULED) {
                        disabled = ![STATUS.SCHEDULED, STATUS.IN_TRANSIT].includes(status.value);
                    }
                    else if (currentStatus === STATUS.IN_TRANSIT) {
                        disabled = ![STATUS.SCHEDULED, STATUS.IN_TRANSIT].includes(status.value);
                    }
                    else if (currentStatus === STATUS.RECEIVED) {
                        disabled = ![STATUS.COMPLETED].includes(status.value);
                    }
                    else if (currentStatus === STATUS.PARTIAL) {
                        disabled = ![STATUS.RECEIVED, STATUS.COMPLETED].includes(status.value);
                    }

                    return {
                        ...status,
                        disabled: disabled
                    };
                });

                return options;
            },

            validateOrderNumber: function(item) {
                if (item.data.status >= 2) {
                    return item.data.po_number && item.data.po_number.trim() !== '';
                }
                return null;
            },

            handleStatusChange: function(item) {
                if (item.data.status === 3 && !item.data.final_eta) {
                    this.$bvToast.toast(
                        "Scheduled ETA date is required for SCHEDULED status",
                        { title: "Validation Error", autoHideDelay: 3000, variant: "warning" }
                    );
                }
            },

            handleEtaDateChange: function(item) {
                if (Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                    this.$bvToast.toast(
                        "Cannot schedule stock order with 0 items",
                        {title: "Validation Error", autoHideDelay: 3000, variant: "warning"}
                    );
                    item.data.final_eta = null;
                    return;
                }

                if (item.data.final_eta && item.data.status !== 3 && item.product_skus && item.product_skus.length > 0) {
                    item.data.status = 3;
                    this.$bvToast.toast(
                        "Status automatically set to SCHEDULED",
                        {title: "Status Updated", autoHideDelay: 1500, variant:"info"}
                    );
                }
            },

            add_new_stock_order: function () {
                let item = {
                    data: {
                        vendor_id: null,
                        created_by: this.packet.userDetails.username,
                        po_number: null,
                        invoice_number: null,
                        ship_to: null,
                        bill_to: null,
                        receiving_location: null,
                        showDetails: false,
                        showCategories: false,
                        show_receivingdates: false,
                        status: 1,
                        invoice_total: 0,
                        tariff: 0,
                        transport: 0,
                        other_cost: 0
                    },
                    id: null,
                    created_at: null,
                    updated_at: null,
                    created_by: this.packet.userDetails.username,
                }
                this.items.splice(0, 0, item);
            },

            validate: function (item) {
                let errors = [];

                if (item.data.status === 3 && Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                    errors.push({ message: "Cannot set status to SCHEDULED when there are 0 items in the stock order." });
                }

                if (!item.data.vendor_id) {
                    errors.push({ message: "PLEASE INDICATE A VENDOR FOR THIS ORDER BEFORE SAVING." });
                }
                if (!item.data.ship_to) {
                    errors.push({ message: "PLEASE INDICATE A SHIP-TO LOCATION." });
                }
                if (!item.data.receiving_location) {
                    errors.push({ message: "PLEASE INDICATE A RCVNG LOCATION." });
                }

                if (item.data.status >= 2 && (!item.data.po_number || item.data.po_number.trim() === '')) {
                    errors.push({ message: "ORDER NUMBER IS REQUIRED WHEN STATUS IS ORDERED OR BEYOND." });
                }

                if (item.data.status === 3 && !item.data.final_eta) {
                    errors.push({ message: "SCHEDULED ETA DATE IS REQUIRED WHEN STATUS IS SET TO SCHEDULED." });
                }

                const shipToText = this.getLocationText(item.data.ship_to);
                const receivingText = this.getLocationText(item.data.receiving_location);

                if (shipToText === 'MECCA WHOLESALE') {
                    const validLocations = ['9TH ST ', '101 WH', 'FOLCROFT'];
                    if (!validLocations.some(loc => receivingText.includes(loc))) {
                        errors.push({ message: "For Mecca Wholesale shipping, receiving location must be 9th ST, 101 WH, or FOLCROFT." });
                    }
                } else {
                    if (shipToText !== receivingText) {
                        errors.push({ message: "For store locations, receiving location must match the shipping location." });
                    }
                }

                return errors;
            },

            update_stock_order: function (item) {
                let data = item;
                let that = this;

                let errors = this.validate(item);
                if (errors.length > 0) {
                    this.$vex.dialog.alert(
                        { message: errors[0].message }
                    );
                    return
                }
                let path = "/api/vendor/update_stock_order/"
                let s = function (response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            { title: "Error", autoHideDelay: 1500, variant: "danger" }
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "SAVED",
                            { title: "Success", autoHideDelay: 1500, variant: "success" }
                        );
                        that.fetch_orders();
                    }
                }

                let f = function (error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred in saving. Please try again.",
                        { title: "Error", autoHideDelay: 1500, variant: "danger" }
                    );
                }
                Requestor.postSyncP(path, data, this, s, f);
            },

            fetch_orders: function() {
                let that = this;
                let userLocationId = this.packet.userDetails.properties.location_id;
                let userRole = this.packet.userDetails.userrole;

                let data = {
                    status: this.status,
                    location_id: userLocationId,
                    userRole: userRole
                };

                let path = "/api/vendor/get_stock_orders/";
                let s = function(response) {
                    if (response.data.result) {
                        let res = response.data.result;
                        that.items = Array.isArray(res) ? res.map(item => ({
                        ...item,
                        showDetails: false,
                        showCategories: false,
                        show_receivingdates:false,
                        })) : [];

                        that.initializeVendorCounters();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },

            initializeVendorCounters: function() {
                this.vendorOrderCounters = {};

                this.items.forEach(order => {
                    if (order.data.vendor_id && order.data.po_number) {
                        const vendorId = order.data.vendor_id;
                        const parts = order.data.po_number.split('-');

                        if (parts.length > 1) {
                            const numberPart = parseInt(parts[parts.length - 1]);

                            if (!isNaN(numberPart)) {
                                if (!this.vendorOrderCounters[vendorId] || numberPart > this.vendorOrderCounters[vendorId]) {
                                    this.vendorOrderCounters[vendorId] = numberPart;
                                }
                            }
                        }
                    }
                });
            },

            view_item: function(item) {
                this.stock_order_id = item.id;
                this.stock_order_vendor_id = item.data.vendor_id;
                this.$bvModal.show("modal-so-items", {
                    props: {
                        schedule_eta: item.data.final_eta
                    }
                });
            },

            close_so_items: function() {
                this.$bvModal.hide("modal-so-items");
                this.fetch_orders()
            },

            statusFromItemsCount: function(item) {
                let options = this.statuses.map(status => {
                    let disabled = false;

                    if (Array.isArray(item.product_skus) && item.product_skus.length === 0) {
                        disabled = !["NEW"].includes(status.text);
                    }

                    if ([5, 6, 7].includes(status.value)) {
                        disabled = true;
                    }

                    if (item.data && [5, 6, 7].includes(item.data.status) && status.value === 8) {
                        disabled = true;
                    }

                    return {
                        ...status,
                        disabled: disabled
                    };
                });

                return options.filter(s => s.text !== "ALL");
            },

            isReceivingLocationHidden: function(item) {
                const receivingLoc = item.data.receiving_location || '';
                return typeof receivingLoc === 'string' && receivingLoc.includes('9TH ST , 101 wH, FOLCROFT');
            },

            setupLocations: function() {
                const allLocations = this.packet.locations.filter(d => d.text != 'All');
                const userLocationId = this.packet.userDetails.properties.location_id;
                const isAdmin = this.packet.userDetails.userrole === 'admin';

                const excludedLocationTexts = [
                    'All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING'
                ];

                this.locations = allLocations
                    .filter(location => !excludedLocationTexts.includes(location.text))
                    .map(this.replaceMecca);

                if (!isAdmin) {
                    this.locations = this.locations.filter(d => d.value == userLocationId);
                }

                this.receiving_locations = allLocations
                    .filter(location => !excludedLocationTexts.includes(location.text))
                    .map(this.replaceMecca);

                this.filter_locations = [
                    { value: null, text: 'ALL' },
                    ...this.locations
                ];

                this.filter_receiving_locations = [
                    { value: null, text: 'ALL' },
                    ...this.receiving_locations
                ];

                const excludedReceiving = ['All', 'ONLINE SALES', 'OUT OF STOCK', 'MECCA SHIPPING', 'MECCA WHOLESALE'];
                this.receiving_dropdown_locations = allLocations
                    .filter(loc => !excludedReceiving.includes(loc.text))
                    .map(this.replaceMecca);

                if (!isAdmin) {
                    this.receiving_dropdown_locations = this.receiving_dropdown_locations.filter(d => d.value == userLocationId);
                }
            },
        },
        watch: {
            items: {
                handler: function(newItems) {
                    newItems.forEach(item => {
                        // Handle any watcher logic here
                    });
                },
                deep: true
            }
        },
        created: function () {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.vendors.splice(0, 0, { value: null, text: "ALL" });
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.setupLocations();
            this.fetch_orders();
        }
    }
</script>

<style scoped>
    .diver {
        overflow: auto;
        width: 100%;
        height: 600px;
        position: relative;
    }

    td,
    th {
        border: 1px solid;
        width: 300px;
    }

    th {
        background-color: white;
    }

    table {
        table-layout: fixed;
        width: 100%;
        border-collapse: separate; 
        border-spacing: 0; 
    }

    td:nth-child(-n+3), 
    th:nth-child(-n+3) {
        position: sticky;
        left: 0;
        z-index: 1;
        background-color: white;
    }
    td:nth-child(1), th:nth-child(1) {
        left: 0;
    }

    td:nth-child(2), th:nth-child(2) {
        left: 160px;
    }

    td:nth-child(3), th:nth-child(3) {
        left: 310px;
    }

    td:last-child,
    th:last-child {
        position: sticky;
        right: 0;
        z-index: 1;
        background-color: white;
        width: 150px;
    }

    thead tr th {
        position: sticky;
        top: 0;
        z-index: 5;
        background-color: white;
    }

    thead tr th:nth-child(-n+3) {
        z-index: 7;
    }

    thead tr th:last-child {
        z-index: 7;
    }

    tbody tr td:nth-child(-n+3) {
        z-index: 2;
        background-color: white;
    }

    tbody tr td:last-child {
        z-index: 2;
        background-color: white;
    }

    tbody tr td:nth-child(-n+3):hover,
    tbody tr td:last-child:hover {
        background-color: white;
    }
    .diver table {
        border-collapse: separate;
        border-spacing: 0;
    }

    th:first-child,
    th:last-child {
        z-index: 2;
        background-color: white;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

    .box {
        padding: 3px;
        text-align: center;
        margin: 5px;
        background: #c8e6c9;
        color: black;
        border: 1px solid black;
    }

    @media (max-width: 768px) {
        td:nth-child(-n+3),
        th:nth-child(-n+3),
        td:last-child,
        th:last-child,
        thead tr th {
            position: static !important;
            left: auto !important;
            right: auto !important;
            top: auto !important;
            z-index: auto !important;
        }

        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/ListStockOrders.vue